// extracted by mini-css-extract-plugin
module.exports = {"form_input__label":"Salon_form_input__label__1_oaw"};